import styled from "styled-components";

const HeadingStyled = styled.div`
padding: 2rem 10rem 2rem 10rem;
margin: 3rem;
text-align: center;

.title {
    font-size: 3.44rem;
    color: #161616;
    margin-bottom: 0;
}

.subtitle {
    color: #101010;
    font-size: 1.59rem;
    margin-top: 0;
}
`

export default HeadingStyled;
